module.exports = __webpack_public_path__ + "img/gonggao.ca58a214.jpg";